var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.47 24.4554L11.4709 24.4543C12.648 22.9811 14.5847 20.4524 16.2296 17.7841C17.052 16.4501 17.8074 15.0717 18.3586 13.7661C18.9063 12.4687 19.2698 11.2031 19.2698 10.1063C19.2698 4.98523 15.1166 0.833984 9.99746 0.833984C4.87641 0.833984 0.725098 4.9853 0.725098 10.1063C0.725098 11.2024 1.08564 12.4675 1.63015 13.7651C2.17807 15.0708 2.92959 16.4493 3.7495 17.7835C5.38913 20.4517 7.32577 22.9805 8.52593 24.4566C9.2883 25.4034 10.7082 25.403 11.47 24.4554ZM12.4216 10.1063C12.4216 11.443 11.3342 12.5305 9.99746 12.5305C8.66077 12.5305 7.57334 11.443 7.57334 10.1063C7.57334 8.76965 8.66077 7.68223 9.99746 7.68223C11.3342 7.68223 12.4216 8.76965 12.4216 10.1063Z",
    fill: "#FF6700",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOrange);
export default __webpack_public_path__ + "static/media/pin_orange.41c0192680676af08c21b65229af1ae7.svg";
export { ForwardRef as ReactComponent };